import Modal from '@/customComponents/uiComponents/modal/Modal.jsx'
import ModalHeader from '@/customComponents/uiComponents/modal/ModalHeader.jsx'

export default function TermsConditionsPopup({isOpen, onClose}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalHeader title="" onClose={onClose}/>
            <div className="hopn-view-in">
                <h3 className="font-bold mb-2!">Terms &amp; Conditions 🚨</h3>
                <h6 className="font-semibold mb-3!">Booking Received — Finding Your Driver</h6>
                <p>We&rsquo;ve received your booking and are working to match you with the right vehicle and a professional driver. You&rsquo;ll receive a confirmation once your ride is locked in.</p>

                <div className="bg-(--bg-grey) rounded-2xl px-6 py-4 mb-5">
                    <h6 className="font-semibold mb-2!">⚠️ Important:</h6>
                    <p className="mb-0!">Your booking is not yet confirmed. Until a driver accepts and your ride is confirmed, hop&rsquo;n cannot guarantee pickup or be held responsible for any missed flights, delays, or losses related to timing. We appreciate your patience — we&rsquo;re doing our best to serve you as quickly as possible.</p>
                </div>

                <div className="bg-(--accent-green-light) rounded-2xl px-6 py-4 mb-6">
                    <b className="block mb-2">Pending Bookings Disclaimer:</b>
                    <ul className="list-disc pl-5 mb-0!">
                        <li>A booking submitted through the hop&rsquo;n platform is considered pending until it is accepted by a driver and marked as confirmed. During this pending period, hop&rsquo;n does not guarantee pickup or service delivery.</li>
                        <li>Hop&rsquo;n shall not be liable for any losses, including but not limited to missed flights, appointments, or business impacts, resulting from unconfirmed or delayed bookings. We recommend all users book in advance to allow sufficient time for matching and confirmation.</li>
                    </ul>
                </div>

                <button type="button" onClick={onClose}
                        className="w-full py-[15px] rounded-full bg-(--text-primary) text-white text-base border-0 cursor-pointer flex items-center justify-center min-h-[55px]">
                    Okay
                </button>
            </div>
        </Modal>
    )
}
